import { InjectionToken } from '@angular/core';
import { IUrlProvider } from './service/url.provider';
import { IFormProvider } from './service/form.provider';

export const URL_PROVIDERS: InjectionToken<IUrlProvider[]> = new InjectionToken<
  IUrlProvider[]
>('URL_PROVIDERS');
export const FORM_PROVIDERS: InjectionToken<IFormProvider[]> =
  new InjectionToken<IFormProvider[]>('FORM_PROVIDERS');
